<template>
  <div>
    <modal v-if="showLarge" class="confirmation-modal" width="800px"    :value="showModal" effect="fade" @closed="closed"  large >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><span :class="getIcon" aria-hidden="true"></span></center>
        </h4>
      </div>
      <div  class="modal-body information-modal-body " style="height: 100px;padding: 5px 15px; overflow-x: auto;" >
          <span v-html="textMessage"></span>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" class="btn btn-primary " @click="closed('yes')">{{textYes}}</button>
      </div>
    </modal>
    <modal v-else class="confirmation-modal" width="460px"    :value="showModal" effect="fade" @closed="closed"  large >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><span :class="getIcon" aria-hidden="true"></span></center>
        </h4>
      </div>
      <div  class="modal-body information-modal-body " style="height: 100px;padding: 5px 15px; overflow-x: auto;" >
          <span v-html="textMessage"></span>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" class="btn btn-primary " @click="closed('yes')">{{textYes}}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:information-modal");

export default {
  data() {
    return {
      show_modal: false,

      icon: "",
      message: "",
      yes_label: "",
      callback:null,
      show_large:false
    };
  },
  computed: {
    showLarge:{
      get(){
        return this.show_large;
      },
      set(v){
        this.show_large = v;
      }
    },
    getTrue(){
        return true;
    },
    getFalse(){
        return false;
    },
    getIcon(){
      return this.icon || "glyphicon glyphicon-ok";
    },
    textYes() {
      return this.yes_label || "完了";
    },
    textMessage() {
      return this.message;
    },

    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow(data) {
        debug_msg("data",data)
        this.showLarge = data.large;
      this.icon = data.icon;
      this.yes_label = data.yes_label || "OK";
      this.yes_color = data.yes_color || "primary";
      this.message = data.message;
      this.show_modal = true;
    },
    closed(mode) {
        this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showInformationIconModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>

.glyphicon {
    font-size: 35px;
}
.information-modal-body {
  height: 250px;
  overflow-y: auto;
}

.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// information-icon-modal.vue?0518b4fc